import { cn } from '@/utils'

interface PersonaProfilePhotoProps {
  name: string
  /** Maps from the persona's `avatarUrl` data field (kept for the portability contract). */
  photoUrl?: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const SIZE_CLASSES: Record<NonNullable<PersonaProfilePhotoProps['size']>, string> = {
  sm: 'w-8 h-8 text-sm',
  md: 'w-12 h-12 text-lg',
  lg: 'w-16 h-16 text-xl',
}

export function PersonaProfilePhoto({ name, photoUrl, size = 'md', className }: PersonaProfilePhotoProps) {
  const sizeCls = SIZE_CLASSES[size]
  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt={name}
        className={cn('rounded-full object-cover shrink-0', sizeCls, className)}
      />
    )
  }
  return (
    <div
      aria-label={name}
      className={cn(
        'rounded-full bg-linear-to-br from-primary to-primary/80',
        'flex items-center justify-center text-primary-foreground font-medium shrink-0',
        sizeCls,
        className,
      )}
    >
      {name.charAt(0).toUpperCase()}
    </div>
  )
}
